const EARTH_RADIUS_KM = 6371;

/** Great-circle (haversine) distance in km between two `[longitude, latitude]` points. */
export function greatCircleKm(
  [longitudeA, latitudeA]: readonly [number, number],
  [longitudeB, latitudeB]: readonly [number, number],
): number {
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const deltaLatitude = toRadians(latitudeB - latitudeA);
  const deltaLongitude = toRadians(longitudeB - longitudeA);
  const a =
    Math.sin(deltaLatitude / 2) ** 2 +
    Math.cos(toRadians(latitudeA)) *
      Math.cos(toRadians(latitudeB)) *
      Math.sin(deltaLongitude / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
}
